import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export function useFormProfileOptions() {
  const { t } = useTranslation("formProfile");

  const RELATIONSHIP_OPTIONS_FIRST_PERSON = useMemo(
    () => [
      { label: t("formProfile.relationshipFirstPerson.father"), value: "พ่อ" },
      { label: t("formProfile.relationshipFirstPerson.mother"), value: "แม่" },
      {
        label: t("formProfile.relationshipFirstPerson.spouse"),
        value: "คู่สมรส (สามี/ภรรยา)",
      },
      { label: t("formProfile.relationshipFirstPerson.child"), value: "ลูก" },
      {
        label: t("formProfile.relationshipFirstPerson.brother"),
        value: "พี่ชาย/น้องชาย",
      },
      {
        label: t("formProfile.relationshipFirstPerson.sister"),
        value: "พี่สาว/น้องสาว",
      },
      {
        label: t("formProfile.relationshipFirstPerson.grandfather"),
        value: "ปู่ / ตา",
      },
      {
        label: t("formProfile.relationshipFirstPerson.grandmother"),
        value: "ย่า / ยาย",
      },
      {
        label: t("formProfile.relationshipFirstPerson.grandchild"),
        value: "หลาน",
      },
      {
        label: t("formProfile.relationshipFirstPerson.uncle"),
        value: "ลุง / น้า",
      },
      {
        label: t("formProfile.relationshipFirstPerson.aunt"),
        value: "ป้า / อา",
      },
    ],
    [t]
  );

  const RELATIONSHIP_OPTIONS_SECOND_PERSON = useMemo(
    () => [
      {
        label: t("formProfile.relationshipSecondPerson.subordinate"),
        value: "ลูกน้อง / ผู้ใต้บังคับบัญชา",
      },
      {
        label: t("formProfile.relationshipSecondPerson.teammate"),
        value: "เพื่อนร่วมทีม",
      },
      {
        label: t("formProfile.relationshipSecondPerson.supervisor"),
        value: "หัวหน้าแผนก",
      },
      {
        label: t("formProfile.relationshipSecondPerson.executive"),
        value: "ผู้บริหาร",
      },
    ],
    [t]
  );

  const EDUCATION_OPTIONS = useMemo(
    () => [
      {
        label: t("formProfile.educationOptions.low"),
        value: "ปวช/ มัธยมปลาย หรือต่ำกว่า",
      },
      {
        label: t("formProfile.educationOptions.diploma"),
        value: "ปวส./วิชาเฉพาะ",
      },
      { label: t("formProfile.educationOptions.bachelor"), value: "ปริญญาตรี" },
      {
        label: t("formProfile.educationOptions.higher"),
        value: "สูงกว่าปริญญาตรี",
      },
    ],
    [t]
  );

  const CHILD_COUNT_OPTIONS = useMemo(
    () => [
      { label: t("formProfile.childCount.moreThanThree"), value: 3 },
      { label: t("formProfile.childCount.two"), value: 2 },
      { label: t("formProfile.childCount.one"), value: 1 },
      { label: t("formProfile.childCount.none"), value: 0 },
    ],
    [t]
  );

  const MARITAL_STATUS_OPTIONS = useMemo(
    () => [
      { label: t("formProfile.maritalStatus.divorced"), value: "divorced" },
      { label: t("formProfile.maritalStatus.widowed"), value: "widowed" },
      { label: t("formProfile.maritalStatus.single"), value: "single" },
      { label: t("formProfile.maritalStatus.married"), value: "married" },
    ],
    [t]
  );

  const MARITAL_STATUS_OPTIONS_TH = useMemo(
    () => [
      {
        label: t("formProfile.maritalStatus.divorced"),
        value: "หย่า/แยกกันอยู่",
      },
      { label: t("formProfile.maritalStatus.widowed"), value: "หม้าย" },
      { label: t("formProfile.maritalStatus.single"), value: "โสด" },
      { label: t("formProfile.maritalStatus.married"), value: "สมรส" },
    ],
    [t]
  );

  return {
    RELATIONSHIP_OPTIONS_FIRST_PERSON,
    RELATIONSHIP_OPTIONS_SECOND_PERSON,
    EDUCATION_OPTIONS,
    CHILD_COUNT_OPTIONS,
    MARITAL_STATUS_OPTIONS,
    MARITAL_STATUS_OPTIONS_TH,
  };
}

export const MARITAL_STATUS_TRANSLATIONS = [
  { en: "divorced", th: "หย่า/แยกกันอยู่" },
  { en: "widowed", th: "หม้าย" },
  { en: "single", th: "โสด" },
  { en: "married", th: "สมรส" },
];
export function reverseMaritalStatus(value) {
  const entry = Object.entries(MARITAL_STATUS_TRANSLATIONS).find(
    ([_, translated]) => translated === value
  );
  return entry ? entry[0] : value; // return the key (e.g., "divorced")
}
export function normalizeMaritalStatus(status, MARITAL_STATUS_TRANSLATIONS) {
  const englishKeys = Object.keys(MARITAL_STATUS_TRANSLATIONS);
  const thaiValues = Object.values(MARITAL_STATUS_TRANSLATIONS);

  // If already in English (key exists), return its Thai translation
  if (englishKeys.includes(status)) return MARITAL_STATUS_TRANSLATIONS[status];

  // If already in Thai (value exists), return as-is
  if (thaiValues.includes(status)) return status;

  // If unknown, return status as fallback
  return status;
}
export const FORM_INITIAL_VALUES = {
  title: "",
  firstNameTh: "",
  middleNameTh: "",
  lastNameTh: "",
  firstNameEn: "",
  middleNameEn: "",
  lastNameEn: "",
  gender: "",
  dob: "",
  idPassport: "",
  idCard: "",
  phoneNumber: "",
  email: "",
  status: "single",
  province: "",
  district: "",
  education: "ปริญญาตรี",
  children: 0,

  currentAddress: "",
  currentProvince: "",
  currentDistrict: "",
  currentSubDistrict: "",
  currentPostalCode: "",

  idCardAddress: "-",
  idCardProvince: "1",
  idCardDistrict: "1002",
  idCardSubDistrict: "100201",
  idCardPostalCode: 10300,

  first_name_1: "-",
  last_name_1: "-",
  phone_1: "0000000000",
  relationship_1: "พ่อ",

  first_name_2: "-",
  last_name_2: "-",
  phone_2: "0000000000",
  relationship_2: "เพื่อนร่วมทีม",
};
